import { render, staticRenderFns } from "./CouetteFlowViz.vue?vue&type=template&id=70f33685&scoped=true"
import script from "./CouetteFlowViz.vue?vue&type=script&lang=js"
export * from "./CouetteFlowViz.vue?vue&type=script&lang=js"
import style0 from "./CouetteFlowViz.vue?vue&type=style&index=0&id=70f33685&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f33685",
  null
  
)

export default component.exports